// Keep the basemap generator and travel markers in this same coordinate frame.
// Each SVG unit is one degree: longitude increases right, latitude increases up.
export const MAP_WIDTH = 360;
export const MAP_HEIGHT = 180;

export function projectCoordinates(latitude: number, longitude: number) {
  if (
    !Number.isFinite(latitude) ||
    !Number.isFinite(longitude) ||
    latitude < -90 || latitude > 90 ||
    longitude < -180 || longitude > 180
  ) {
    throw new RangeError("Map coordinates must be valid latitude/longitude degrees.");
  }

  return { x: longitude + MAP_WIDTH / 2, y: MAP_HEIGHT / 2 - latitude };
}
